import { CALL_API } from './api'
import { getAccessToken, getBSRSToken, getServiceToken } from 'Lib'

export default store => next => action => {
  const entry = action[CALL_API]

  if (typeof entry !== 'object') return next(action)

  let token
  const entryType = entry.types[0]
  if (entryType.startsWith("CORE") || entryType.startsWith("O365")) {
    token = getBSRSToken()
  }
  // else if (entryType.startsWith("O365")) {
  //   const { service_token } = getServiceToken()
  //   token = service_token
  // }

  // if(entryType.startsWith("CORE")){
  //   token = getBSRSToken()
  // }else if(entry.types[0].startsWith("O365")){ 
  //   if(typeof(entry.tokentype) !== undefined && entry.tokentype === 'service' ){ 
  //     const { service_token } = getServiceToken()
  //     token = service_token
  //   }
  //   else token = getAccessToken()
  // }

  if (!token) return next(action)

  entry.headers = { ...entry.headers, 'Authorization': `Bearer ${token}` }

  next(action)
}


// WEBPACK FOOTER //
// ./src/middlewares/setToken.js